import { InputText } from "primereact/inputtext";
import { InputMask } from 'primereact/inputmask';

import ModalSeplag from "../../components/ModalSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";

import { useFormik } from 'formik';

import {
  getFormErrorMessage,
  printToast,
  summaryAlteracaoSucessoPadrao,
  detailAlteracaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
  detailCriacaoSucessoPadrao
} from "../../config/global";

import { initForm, salvar, pesquisarPorId } from '../../service/empresa'
import { Button } from "primereact/button";
import { useEffect, useState } from "react";

const ModalCadastro = ({ visible, setVisible, onSalvar, empresa }) => {

  const [form, setForm] = useState(initForm)

  useEffect(() => {
    if (empresa) {
      pesquisarPorId(empresa.idenEmpresa).then(res => {
        setForm({ ...res, cnpjMask: res.cnpj })
      })
    }
  }, [empresa])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => { },
    onSubmit: async (data) => {
      let reg = /(\.)|(\/)|(\-)/g
      let jsonPost = {
        ...data,
        cnpj: parseInt(data.cnpjMask.toString().replace(reg, ''))
      }
      let summary = data.idenEmpresa > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
      let detail = data.idenEmpresa > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;

      salvar(jsonPost).then(res => {
        printToast({ summary, detail });
        setVisible(false)
        onSalvar && onSalvar();
      })
    }
  });

  return (
    <ModalSeplag
      visible={visible}
      titulo="Pessoa Jurídica"
      fechar={() => setVisible(false)}
      type="NONE"
    >
      <form onSubmit={formik.handleSubmit} className="p-grid">
        <RotuloSeplag obrigatorio nome="Nome Fantasia" cols="12 6">
          <InputText
            id="nomeFantasia"
            name="nomeFantasia"
            value={formik.values.nomeFantasia}
            onChange={(e) => formik.handleChange(e)}
          />
          {getFormErrorMessage('nomeFantasia', formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Razão Social" cols="12 6">
          <InputText
            id="razaoSocial"
            name="razaoSocial"
            value={formik.values.razaoSocial}
            onChange={(e) => formik.handleChange(e)}
          />
          {getFormErrorMessage('razaoSocial', formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="Inscrição Estadual" cols="12 6">
          <InputText
            id="descInscEstadual"
            name="descInscEstadual"
            value={formik.values.descInscEstadual}
            onChange={(e) => formik.handleChange(e)}
          />
          {getFormErrorMessage('descInscEstadual', formik)}
        </RotuloSeplag>

        <RotuloSeplag obrigatorio nome="CNPJ" cols="12 6">

          <InputMask
            id="cnpjMask"
            name="cnpjMask"
            onChange={(e) => formik.handleChange(e.originalEvent)}
            value={formik.values.cnpjMask}
            mask="99.999.999/9999-99"
            placeholder="99.999.999/9999-99"
          />
          {getFormErrorMessage('cnpjMask', formik)}
        </RotuloSeplag>

        <div className="p-col-12 p-md-3">
          <Button
            label={formik.values.idenEmpresa > 0 ? 'Editar' : "Enviar"}
            icon={formik.values.idenEmpresa > 0 ? "pi pi-pencil" : "pi pi-check"}
            autoFocus
            className="p-button-raised margin-app-entre-button"
            type="submit"
          />
        </div>
        {/* <div className="p-col-12 p-md-3">
          <Button
            type='button'
            label="Cancelar"
            icon="pi pi-times"
            onClick={handleCloseModalAdicionarTipoCertidao}
            className="p-button-outlined p-button-danger p-mb-1"
          />
        </div> */}
      </form>
    </ModalSeplag>
  )
}


export default ModalCadastro;